// extracted by mini-css-extract-plugin
module.exports = {"Security":"style_Security__37it5","Tittle":"style_Tittle__1mpT4","DisconectInfo":"style_DisconectInfo__2nH3L","DisconectBtn":"style_DisconectBtn__25nPZ"};